'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseTbody = require('../base-table/base-tbody.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledTBody = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { breakpoints , children , className , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseTbody.BaseTBody, _extends({}, otherProps, {
        ref: ref,
        className: classnames__default.default({
            'bf-table__standard-tbody': true,
            'bf-table__standard-tbody--breakpoints': !!breakpoints,
            [`${className}`]: !!className
        })
    }), children);
});
const blockTbody = styled.css`
  display: block;
`;
const tableTbody = styled.css`
  display: table-row-group;
`;
const getTbodyBreakpoints = (breakpoints)=>{
    return breakpoints.map((breakpoint, index)=>{
        return styled.css`
      @media (min-width: ${breakpoint}px) {
        ${index % 2 === 0 ? tableTbody : blockTbody}
      }
    `;
    });
};
const StyledTBody = styled__default.default(UnstyledTBody)`
  ${blockTbody}
  ${({ breakpoints  })=>getTbodyBreakpoints(breakpoints || [])}
`;
/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/tbody
 * @param props TBodyProps
 * @returns FunctionComponent<TBodyProps>
 */ const TBody = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledTBody, _extends({
        ref: ref
    }, props)));
});

exports.TBody = TBody;
//# sourceMappingURL=tbody.js.map
